<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div v-if="!modoEdicao">
        <!-- Tabela -->
        <div v-if="lsDados.length > 0">
            <div class="table-wrapper row-space"><table>
                <thead><tr>
                    <th>OS</th>
                    <th>Nome/Identificação</th>
                    <th>Equipamento</th>
                    <th>Placa</th>
                    <th>Fornecedor</th>
                    <th>Abertura</th>
                    <th>Status</th>
                </tr></thead>

                <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarCadastro(obj)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                >
                    <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.cdos) }}</td>
                    <td>{{ obj.nmos }}</td>
                    <td class="col-width-char30">{{ obj.nmequipamento }}</td>
                    <td class="col-width-char10 center">{{ obj.placa }}</td>
                    <td class="col-width-char30">{{ obj.nmfornecedor }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtabertura) }}</td>
                    <td class="col-width-char30">{{ obj.nmstatus }}</td>
                </tr></tbody>
            </table></div>

            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>
        </div>

        <div class="row-end">
            <button class="btn-small" @click="novoCadastro()">Incluir</button>
            <button class="btn-small" @click="closeForm()">Fechar</button>
        </div>
    </div>


    <div v-if="modoEdicao">
        <!-- CABEÇALHO -->
        <div v-if="showOsEdit" class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdos) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Ordem de Serviço (Nome / Identificação)</label>
                    <input type="text" v-model="objEdicao.nmos" maxlength="100" v-uppercase />
                </div>

                <div class="form-item-data">
                    <label class="label-caption">Data Abertura</label>
                    <input type="date" v-model="objEdicao.dtabertura" />
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Status</label>
                    <div class="field-label">{{ objEdicao.nmstatus || '-' }}</div>
                </div>
            </div>

            <div class="row row-space">
                <div class="form-item">
                    <EquipamentoFrame :initId="objEdicao.idequipamento" v-model:objSelecionado="equipamentoSelecionado" />
                </div>

                <div class="form-item">
                    <FornecedorFrame :initId="objEdicao.idfornecedor" v-model:objSelecionado="fornecedorSelecionado" />
                </div>
            </div>

            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Observações</label>
                    <textarea v-model="objEdicao.obs" maxlength="1000" rows="4" style="resize:none;" />
                </div>
            </div>

            <div class="row-end">
                <button class="btn-confirm" @click="salvarCabecalho">Avançar</button>
                <button class="btn-cancel" @click="cancelEdicao">Cancelar</button>
            </div>
        </div>


        <!-- CABEÇALHO VIEW -->
        <div v-if="!showOsEdit" class="form-edit-page row-space">
            <div class="row">
                <div class="form-item-char10">
                    <label class="label-caption">OS</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(osView.cdos) }}</div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Abertura</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(osView.dtabertura) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome/Descrição</label>
                    <div class="field-label">{{ osView.nmos }}</div>
                </div>
                
                <div class="form-item-char40">
                    <label class="label-caption">Equipamento</label>
                    <div class="field-label">{{ osView.nmequipamento }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Situação</label>
                    <div class="field-label">{{ osView.nmstatus }}</div>
                </div>
            </div>
        </div>


        <div v-if="showItemEdit" class="form-edit-page">
            <div class="servicos-section row-space">
                <div class="servicos-header">
                    <div class="servicos-title">
                        <h3>Serviços da manutenção preventiva</h3>
                        <p>Selecione os serviços que deseja incluir nesta solicitação.</p>
                    </div>

                    <div class="servicos-contador">
                        {{ lsItens.length }} selecionado(s)
                    </div>
                </div>


                <div class="servicos-resumo">
                    <div class="servicos-km-atual">
                        <label>Km/Horas atual do equipamento</label>
                        <strong>{{ kmHorasAtual !== null ? Funcoes.formatInteger(kmHorasAtual) : '-' }}</strong>
                    </div>

                    <div
                        class="sem-preventiva-card"
                        :class="{ ativo: semPreventiva }"
                        @click="toggleSemPreventiva"
                    >
                        <div class="sem-preventiva-check">
                            {{ semPreventiva ? '✓' : '' }}
                        </div>

                        <div>
                            <strong>Não solicitar manutenção preventiva</strong>
                            <span>Use esta opção quando a solicitação for referente a problema mecânico, corretiva ou outro serviço avulso.</span>
                        </div>
                    </div>
                </div>


                <div class="servicos-grid">
                    <div
                        v-for="obj in lsManutencoes"
                        :key="obj.idservico"
                        class="servico-card"
                        :class="{
                            selecionado: servicoEstaSelecionado(obj),
                            vencido: obj.ckvencido === 'S',
                            alerta: obj.ckvencido !== 'S' && obj.ckalerta === 'S',
                            desabilitado: semPreventiva
                        }"
                        @click="toggleServico(obj)"
                    >
                        <div class="servico-card-top">
                            <div>
                                <div class="servico-nome">{{ obj.nmservico }}</div>
                            </div>

                            <div class="servico-check">
                                {{ servicoEstaSelecionado(obj) ? '✓' : '' }}
                            </div>
                        </div>

                        <div class="servico-status">
                            <span v-if="obj.ckvencido === 'S'" class="tag tag-vencido">Vencido</span>
                            <span v-else-if="obj.ckalerta === 'S'" class="tag tag-alerta">Próximo do vencimento</span>
                            <span v-else class="tag tag-ok">Em dia</span>
                        </div>

                        <div class="servico-info">
                            <div>
                                <label>Última execução</label>
                                <strong>
                                    {{ obj.kmultima ? Funcoes.formatInteger(obj.kmultima) + ' km' : '-' }}
                                </strong>
                                <small>{{ obj.dtultima ? Funcoes.formatDateFromJson(obj.dtultima) : 'Sem data' }}</small>
                            </div>

                            <div>
                                <label>Próxima execução</label>
                                <strong>
                                    {{ obj.kmproxima ? Funcoes.formatInteger(obj.kmproxima) + ' km' : '-' }}
                                </strong>
                                <small>{{ obj.dtproxima ? Funcoes.formatDateFromJson(obj.dtproxima) : 'Sem data' }}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            

            <div class="row-end">
                <button class="btn-confirm" @click="abrirModalEncerrar">Confirmar e Encerrar</button>
                <button @click="cancelEdicao">Voltar</button>
            </div>
        </div>
    </div>


    <ConfirmModal ref="confirmModal" />
</template>

<script setup>
import { onMounted, ref, reactive, computed } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import EquipamentoFrame from '@/components/frames/EquipamentoFrame.vue';
import FornecedorFrame from '@/components/frames/FornecedorFrame.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);

const confirmModal = ref(null)
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const msgAlerta = ref(null);

const equipamentoSelecionado = ref(null);
const fornecedorSelecionado = ref(null);
const osView = reactive({});
const showItemEdit = ref(false);
const showOsEdit = ref(true);


// Itens
const lsItens = ref([]);
const lsManutencoes = ref([]);
const semPreventiva = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


function criarManutOs() {
    return reactive({
        id: 0,
        idmunicipio: 0,
        idequipamento: 0,
        idfornecedor: 0,
        cdos: 0,
        nmos: null,
        dtabertura: null,
        obs: null,
        idlogin: 0,
    });
}
const objEdicao = criarManutOs();


async function abrirModalEncerrar(){
    if (lsItens.value.length === 0 && !semPreventiva.value){
        msgAlerta.value = 'Selecione algum serviço de manutenção preventiva ou marque que esta solicitação não possui preventiva.';
        return;
    }

    msgAlerta.value=null;
    const confirmado = await confirmModal.value.show({
        message: "Confirma encerramento dessa solicitação e envio para orçamento?",
        confirmText: 'Sim',
        cancelText: 'Não'
    })
    if (confirmado){salvarEncerraDigitacao()}
}


async function atualizarOsView(idOs) {
    try {
        msgAlerta.value = null;
        
        const respOs = await Api.genericPost('/dados/manut_os', {idmunicipio: globalStore.idmunicipio, id: idOs});
        if (respOs.length>0){
            Object.assign(osView, respOs[0]);
        }else{
            msgAlerta.value = 'Não foi possível ler os dados da OS';
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}


function cancelEdicao(){
    if (lsDados.value.length > 0){
        msgAlerta.value=null;
        modoEdicao.value = false;
        showOsEdit.value = false;
        showItemEdit.value = false;
    }else{
        closeForm();
    }
}

function closeForm() { emit('close'); }


async function editarCadastro(obj) {
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.getCadastroById('manut_os', obj.id);
        Object.assign(objEdicao, req[0]);
        modoEdicao.value=true;
        showOsEdit.value=true;
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


function novoCadastro() {
    modoEdicao.value = true;
}


function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * globalStore.itensPorPagina;
    const endIndex = (startIndex + globalStore.itensPorPagina);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


async function lerDados() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const payload = {
            idmunicipio: globalStore.idmunicipio,
            intparam1: 1,
            idlogin: globalStore.idlogin,
        };

        const req = await Api.genericPost('/dados/manut_os', payload);
        lsDadosMain.value = req || [];
        currentPage.value = 1;
        showPagination.value = (lsDadosMain.value.length > globalStore.itensPorPagina);
        updatePaginatedData();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function salvarCabecalho() {
    try {
        msgAlerta.value = salvarCabecalhoValidacao();
        if (msgAlerta.value) return;

        // map frames -> ids
        objEdicao.idequipamento = equipamentoSelecionado.value.id;
        objEdicao.idfornecedor = fornecedorSelecionado.value?.id || 0;
        objEdicao.idmunicipio = globalStore.idmunicipio;
        objEdicao.idlogin = globalStore.idlogin;

        isLoading.value = true;
        const resp = await Api.genericPut('/cad/manut_os', objEdicao);

        if (resp.bolok === 1) {
            await atualizarOsView(resp.id);

            const reqManutencoes = await Api.genericPost('/frota/manutencao/status', {
                idmunicipio: objEdicao.idmunicipio,
                idequipamento: objEdicao.idequipamento});
            lsManutencoes.value = reqManutencoes || [];

            showOsEdit.value = false;
            showItemEdit.value = true;
        } else {
            msgAlerta.value = resp?.erro || 'Não foi possível salvar.';
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}
function salvarCabecalhoValidacao(){
    let r = Validar.id(equipamentoSelecionado.value, 'Informe o Equipamento');
    if (!r.ok) return r.msg;
    r = Validar.texto(objEdicao.nmos, 'Informe a Descrição');
    if (!r.ok) return r.msg;
    r = Validar.data(objEdicao.dtabertura, -1000, 'Data de Abertura');
    if (!r.ok) return r.msg;
    return null;
}


async function salvarEncerraDigitacao(){
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        
        await salvarItens();

        const payload = {
            id: osView.id,
            solicitacao_idlogin: globalStore.idlogin,
            idlogin: globalStore.idlogin};
        const resp = await Api.genericPut('/cad/manut_os', payload);

        if (resp.bolok === 1) {
            closeForm();
        } else {
            msgAlerta.value = resp?.erro || 'Não foi possível encerrar digitação da OS';
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function salvarItens() {
    for (const item of lsItens.value) {
        const payload = {
            id: 0,
            idos: osView.id,
            idproduto: 0,
            idservico: item.idservico,
            qtdd: 1,
            vlunitario: 0,
            vlliquido: 0,
            ckexecutado: 'N',
            obs: item.obs,
            idlogin: globalStore.idlogin
        };

        const resp = await Api.genericPut('/cad/manut_os_item', payload);

        if (resp?.bolok != 1) {
            throw new Error(resp?.erro || `Não foi possível salvar o serviço ${item.nmservico}`);
        }
    }
}


async function startPage(){
    await lerDados();
    if (lsDados.value.length === 0){modoEdicao.value = true;}
}

//------------------------------------------------------------------------------------
function servicoEstaSelecionado(obj) {
    return lsItens.value.some(item => item.idservico === obj.idservico);
}

function toggleServico(obj) {
    if (semPreventiva.value) {
        semPreventiva.value = false;
    }

    const index = lsItens.value.findIndex(item => item.idservico === obj.idservico);

    if (index >= 0) {
        lsItens.value.splice(index, 1);
        return;
    }

    lsItens.value.push({
        idservico: obj.idservico,
        cdservico: obj.cdservico,
        nmservico: obj.nmservico,
        obs: null,
        origemManutencao: obj
    });
}

const kmHorasAtual = computed(() => {
    if (lsManutencoes.value.length === 0) return null;
    return lsManutencoes.value[0].kmatual;
});


function toggleSemPreventiva() {
    semPreventiva.value = !semPreventiva.value;

    if (semPreventiva.value) {
        lsItens.value = [];
    }
}
//------------------------------------------------------------------------------------

onMounted(startPage);
</script>


<style scoped>
.servicos-section,
.servicos-section * {
    text-align: left;
}

.servicos-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.servicos-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
}

.servicos-title {
    flex: 1;
}

.servicos-title h3 {
    margin: 0;
    font-size: 18px;
    color: #111827;
}

.servicos-title p {
    margin: 4px 0 0;
    color: #6b7280;
    font-size: 13px;
}

.servicos-contador {
    background: #f3f4f6;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 8px 12px;
    font-weight: 700;
    text-align: center;
}

.servicos-resumo {
    display: grid;
    grid-template-columns: 220px 1fr;
    gap: 12px;
    align-items: stretch;
}

.servicos-km-atual {
    border: 1px solid #d1d5db;
    border-radius: 10px;
    padding: 10px 12px;
    background: #f9fafb;
}

.servicos-km-atual label {
    display: block;
    font-size: 12px;
    color: #6b7280;
    margin-bottom: 4px;
}

.servicos-km-atual strong {
    display: block;
    font-size: 22px;
    color: #111827;
}

.sem-preventiva-card {
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid #d1d5db;
    border-left: 5px solid #9ca3af;
    border-radius: 10px;
    padding: 10px 12px;
    background: #fff;
    cursor: pointer;
}

.sem-preventiva-card.ativo {
    border-color: #2563eb;
    border-left-color: #2563eb;
    background: #eff6ff;
}

.sem-preventiva-check,
.servico-check {
    width: 24px;
    height: 24px;
    min-width: 24px;
    border-radius: 50%;
    border: 1px solid #9ca3af;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    color: #2563eb;
    background: #fff;
    text-align: center;
}

.sem-preventiva-card strong {
    display: block;
    font-size: 14px;
    color: #111827;
}

.sem-preventiva-card span {
    display: block;
    font-size: 12px;
    color: #6b7280;
    margin-top: 2px;
}

.servicos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 12px;
}

.servico-card {
    border: 1px solid #d1d5db;
    border-left: 5px solid #9ca3af;
    border-radius: 10px;
    padding: 12px;
    background: #fff;
    cursor: pointer;
    transition: 0.15s;
}

.servico-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.servico-card.selecionado {
    border-color: #2563eb;
    border-left-color: #2563eb;
    background: #eff6ff;
}

.servico-card.vencido {
    border-left-color: #dc2626;
}

.servico-card.alerta {
    border-left-color: #f59e0b;
}

.servico-card.desabilitado {
    opacity: 0.55;
}

.servico-card-top {
    display: flex;
    justify-content: space-between;
    gap: 8px;
}

.servico-nome {
    font-weight: 700;
    color: #111827;
}

.servico-status {
    margin-top: 10px;
}

.tag {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
}

.tag-vencido {
    background: #fee2e2;
    color: #991b1b;
}

.tag-alerta {
    background: #fef3c7;
    color: #92400e;
}

.tag-ok {
    background: #dcfce7;
    color: #166534;
}

.servico-info {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-top: 12px;
}

.servico-info label {
    display: block;
    font-size: 11px;
    color: #6b7280;
}

.servico-info strong {
    display: block;
    font-size: 14px;
}

.servico-info small {
    color: #6b7280;
}
</style>